import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

const PromotionSectionSkeleton = () => {
  return (
    <Box sx={{ width: '100%', p: 2 }}>
      {/* Title Skeleton */}
      <Skeleton 
        variant="rectangular" 
        width="60%" 
        height={40} 
        sx={{ 
          borderRadius: 1,
          mb: 2,
          bgcolor: 'rgba(0, 0, 0, 0.1)'
        }} 
      />

      {/* Content Skeletons */}
      {[...Array(3)].map((_, index) => (
        <Box 
          key={index} 
          sx={{ 
            mb: 3,
            p: 2,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 1
          }}
        >
          {/* Section Title */}
          <Skeleton 
            variant="text" 
            width="40%" 
            height={32} 
            sx={{ mb: 2 }} 
          />

          {/* Content Lines */}
          <Skeleton variant="text" width="100%" sx={{ mb: 1 }} />
          <Skeleton variant="text" width="90%" sx={{ mb: 1 }} />
          <Skeleton variant="text" width="95%" sx={{ mb: 1 }} />
          <Skeleton variant="text" width="85%" />
        </Box>
      ))}
    </Box>
  );
};

export default PromotionSectionSkeleton; 